export interface IncomeTaxAnnualList {
    no?: string,
    name?: string,
    isChecked?: boolean,
    url?: string,
    isSelect?: number,
    indent?: number,
    id?: number | null,
    year?:string | null,
    accountBookId?:number | null
}

let list: IncomeTaxAnnualList[] = [
    {
        name: "科目余额表",
        no: "",
        url: "Balance",
        indent: 0,
        isChecked: false,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    {
        name: "企业基础信息表",
        no: "A000000",
        url: "AnnualEITA000000",
        indent: 0,
        isChecked: false,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    {
        name: "中华人民共和国企业所得税年度纳税申报表（A类）",
        no: "A100000",
        url: "AnnualEITA100000",
        indent: 0,
        isChecked: false,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    // {
    //     name: "一般企业收入明细表",
    //     no: "A101010",
    //     url: "AnnualEITA101010",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect: 1,
    //     id: null,
    //     year:null,
    //     accountBookId:null,
    // },
    // {
    //     name: "金融企业收入明细表",
    //     no: "A101020",
    //     url: "AnnualEITA101020",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "一般企业成本支出明细表",
    //     no: "A102010",
    //     url: "AnnualEITA102010",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect: 1,
    //     id: null,
    //     year:null,
    //     accountBookId:null,
    // },
    // {
    //     name: "金融企业支出明细表",
    //     no: "A102020",
    //     url: "AnnualEITA102020",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "事业单位、民间非营利组织收入、支出明细表",
    //     no: "A103000",
    //     url: "AnnualEITA103000",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "期间费用明细表",
    //     no: "A104000",
    //     url: "AnnualEITA104000",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect: 1,
    //     id: null,
    //     year:null,
    //     accountBookId:null,
    // },
    {
        name: "纳税调整项目明细表",
        no: "A105000",
        url: "AnnualEITA105000",
        indent: 2,
        isChecked: false,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    // {
    //     name: "视同销售和房地产开发企业特定业务纳税调整明细表",
    //     no: "A105010",
    //     url: "AnnualEITA105010",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "未按权责发生制确认收入纳税调整明细表",
    //     no: "A105020",
    //     url: "AnnualEITA105020",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "投资收益纳税调整明细表",
    //     no: "A105030",
    //     url: "AnnualEITA105030",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "专项用途财政性资金纳税调整明细表",
    //     no: "A105040",
    //     url: "AnnualEITA105040",
    //     indent: 2,
    //     isChecked: false,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    {
        name: "职工薪酬支出及纳税调整明细表",
        no: "A105050",
        url: "AnnualEITA105050",
        indent: 4,
        isChecked: false,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    {
        name: "广告费和业务宣传费跨年度纳税调整明细表",
        no: "A105060",
        url: "AnnualEITA105060",
        indent: 4,
        isChecked: true,
        isSelect: 1,
        id: null,
        year:null,
        accountBookId:null,
    },
    // // {
    // //     name: "捐赠支出及纳税调整明细表",
    // //     no: "A105070",
    // //     url: "AnnualEITA105070",
    // //     indent: 4,
    // //     isChecked: false,
    // //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // // },
    {
        name: "资产折旧、摊销及纳税调整明细表",
        no: "A105080",
        url: "AnnualEITA105080",
        indent: 4,
        isChecked: false,
        isSelect: 0,
        id: null,
        year:null,
        accountBookId:null,
    },
    // {
    //     name: "资产损失税前扣除及纳税调整明细表",
    //     no: "A105090",
    //     url: "AnnualEITA105090",
    //     indent: 4,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "企业重组及递延纳税事项纳税调整明细表",
    //     no: "A105100",
    //     url: "AnnualEITA105100",
    //     indent: 4,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "政策性搬迁纳税调整明细表",
    //     no: "A105110",
    //     url: "AnnualEITA105110",
    //     indent: 4,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "特殊行业准备金及纳税调整明细表",
    //     no: "A105120",
    //     url: "AnnualEITA105120",
    //     indent: 4,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    {
        name: "企业所得税弥补亏损明细表",
        no: "A106000",
        url: "AnnualEITA106000",
        indent: 0,
        isChecked: true,
        isSelect: 0,
        id: null,
        year:null,
        accountBookId:null,
    },
    // {
    //     name: "免税、减计收入及加计扣除优惠明细表",
    //     no: "A107010",
    //     url: "AnnualEITA107010",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "符合条件的居民企业之间的股息、红利等权益性投资收益优惠明细表",
    //     no: "A107011",
    //     url: "AnnualEITA107011",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "研发费用加计扣除优惠明细表",
    //     no: "A107012",
    //     url: "AnnualEITA107012",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "所得减免优惠明细表",
    //     no: "A107020",
    //     url: "AnnualEITA107020",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "抵扣应纳税所得额明细表",
    //     no: "A107030",
    //     url: "AnnualEITA107030",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    {
        name: "减免所得税优惠明细表",
        no: "A107040",
        url: "AnnualEITA107040",
        indent: 0,
        isChecked: true,
        isSelect: 0,
        id: null,
        year:null,
        accountBookId:null,
    },
    // {
    //     name: "高新技术企业优惠情况及明细表",
    //     no: "A107041",
    //     url: "AnnualEITA107041",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "软件、集成电路企业优惠情况及明细表",
    //     no: "A107042",
    //     url: "AnnualEITA107042",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "税额抵免优惠明细表",
    //     no: "A107050",
    //     url: "AnnualEITA107050",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "境外所得税收抵免明细表",
    //     no: "A108000",
    //     url: "AnnualEITA108000",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "境外所得纳税调整后所得明细表",
    //     no: "A108010",
    //     url: "AnnualEITA108010",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "境外分支机构弥补亏损明细表",
    //     no: "A108020",
    //     url: "AnnualEITA108020",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "跨年度结转抵免境外所得税明细表",
    //     no: "A108030",
    //     url: "AnnualEITA108030",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "跨地区经营汇总纳税企业年度分摊企业所得税明细表",
    //     no: "A109000",
    //     url: "AnnualEITA109000",
    //     indent: 0,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },
    // {
    //     name: "企业所得税汇总纳税分支机构所得税分配表",
    //     no: "A109010",
    //     url: "AnnualEITA109010",
    //     indent: 2,
    //     isChecked: true,
    //     isSelect:1,
    // id: null,
    // year:null,
    // accountBookId:null,
    // },

]


let AnnualEITList = list
export default AnnualEITList
